import React from 'react';
import { TextButton } from 'library/ui';
import { useHistory } from 'react-router';
import { ITeacher } from 'models';

export default function ViewMoreTeachers({ showcaseWorkers }: { showcaseWorkers?: ITeacher[] }) {
    const history = useHistory();
    return (
        <TextButton
            onClick={() =>
                history.push({ pathname: '/teacher-showcase', state: { showcaseWorkers: showcaseWorkers ?? [] } })
            }
        >
            View More Teachers
        </TextButton>
    );
}
